module.exports = __webpack_public_path__ + "static/media/document-unavailable-icon.09ee8143.svg";